import React, { useState, useEffect } from "react";
import { connect } from "react-redux";

import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import DatePicker from "react-datepicker";
import Spinner from "../../common/Spinner";
import { CheckCircleIcon } from "@heroicons/react/20/solid";

import { Actions as ASSETACTIONS } from "../../../store/actions/assetActions";
import { Actions as EMPLOYEEACTIONS } from '../../../store/actions/employeeActions';

import { addMonths, format } from "date-fns";
import Tooltip from "@/tooltip";
import NotificationManager from "react-notifications/lib/NotificationManager";

const AssetEmployee = ({
    asset,
    assignAsset,
    disabled,
    employeeOptions,
    employeesGetListWithSalary,
    saving
}) => {
    const { register, handleSubmit, setValue, watch, control, reset } = useForm();

    const [agreement, setAgreement] = useState()

    useEffect(() => {
        employeesGetListWithSalary()
    }, []);

    const onSubmit = (data) => {

        data.asset = asset.id
        data.agreement = agreement?.value
        data.start = format(data.start, 'yyyy-MM-dd')

        if (!data.agreement || !data.start) {
            NotificationManager.error('Kindly fill all required fields!', 'Assigning Asset')
            return
        }

        assignAsset(data);
    };

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <div className="form-group">
                <div className="col-sm-6 ">
                    <div className="form-material">
                        <label htmlFor="material-text">Employee</label>

                        <Select
                            isDisabled={disabled}
                            options={employeeOptions}
                            value={agreement}
                            onChange={(selected) => {
                                setAgreement(selected)
                            }}
                        />
                    </div>

                </div>
                {/* <div className="col-sm-6">
                    <label className="css-input switch switch-sm switch-success" style={{ marginTop: '2rem', cursor: disabled ? 'not-allowed' : 'pointer' }}>
                        <input
                            type="checkbox"
                            id="definite"
                            ref={register}
                            disabled={disabled}
                            checked={definite}
                            onClick={() => setDefinite(!definite)}
                        />
                        <span></span>
                        <Tooltip content="Only tick this checkbox if this asset should be ignored from payroll">
                            <label htmlFor="definite" style={{ marginBottom: 0 }}>
                                Definite
                            </label>
                        </Tooltip>
                    </label>
                </div> */}
                <div className="col-sm-6">
                    <div className="form-material">

                        <Controller
                            as={
                                <DatePicker
                                    dateFormat="dd MMM yyyy"
                                    className="form-control form-input"
                                />
                            }
                            control={control}
                            id="start"
                            name="start"
                            defaultValue={new Date()}
                            valueName="selected"
                            onChange={([selected]) => {
                                return selected;
                            }}
                            autoComplete='off'
                        />
                        <label htmlFor="start">
                            Assigned At
                        </label>
                    </div>
                    <div className="clearfix"></div>
                </div>
                {/* <div className="col-sm-6">
                    <div className="form-material">
                        <Controller
                            as={
                                <DatePicker
                                    dateFormat="dd MMM yyyy"
                                    className="form-control"
                                />
                            }
                            control={control}
                            id="end"
                            name="end"
                            defaultValue={new Date()}
                            valueName="selected"
                            onChange={([selected]) => {
                                return selected;
                            }}
                            autoComplete='off'
                        />
                        <label htmlFor="end">
                            Expected At
                        </label>
                    </div>
                </div> */}
                <div className="clearfix"></div>
                {!disabled && (
                    <div className="block buttons">
                        <button
                            className="btn btn-success pull-right"
                            type="submit"
                        >
                            {saving ?
                                <Spinner
                                    style={{ height: "1.5em", float: "left", marginRight: 5, float: 'left' }}
                                    className="animate-spin -ml-1 mr-3 h-5 w-5" />
                                : <CheckCircleIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
                            }
                            <div style={{ float: "left" }}>Assign Asset</div>
                        </button>
                    </div>
                )}
            </div>
        </form>
    );
};

const mapStateToProps = (state, ownProps) => {
    const employeeListWithSalary = state.employees?.employeeListWithSalary;

    return {
        employeeOptions: employeeListWithSalary?.map((employee) => ({
            value: employee.id,
            label: `${employee.employeeName} ${employee.employeeSurname}`,
        })),
        asset: state.asset.item,
    };
};

const mapDispatchToProps = (dispatch) => ({
    employeesGetListWithSalary: () => dispatch(EMPLOYEEACTIONS.employeesGetListWithSalary({
        from: format(addMonths(new Date(), -12), 'yyyy-MM-01'),
        to: format(new Date(), 'yyyy-12-31'),
    })),
    assignAsset: (input) => dispatch(ASSETACTIONS.assignAsset(input)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AssetEmployee);
